// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button[data-v-55e48f5c] {\n  background: var(--theme) !important;\n  color: #fff !important;\n  border-radius: 3px;\n  padding: 8px 16px;\n}\n.link[data-v-55e48f5c] {\n  color: var(--theme) !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
